const launcher = {
  props: {
    dynamicClass: ".c-launcher.dynamicLoading",
    className: ".JS-c-launcher-link",
  },

  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-launcher.css", this.props.dynamicClass);

    const launchers = document.querySelectorAll(this.props.className);
    launchers.forEach((launcher) => {
      if (launcher.dataset.paramurldialog) {
        let url;
        if (launcher.href.includes(".html")) {
          url = launcher.href.split(".html")[0];
          launcher.href = url + "--" + launcher.dataset.paramurldialog + ".html";
        } else {
          url = launcher.href.slice(0, -1);
          launcher.href = url + "--" + launcher.dataset.paramurldialog;
        }
      }
    });
  },
};

export default launcher;
